import fetch from '@/utils/fetch'

// 免息活动列表 URL（表格列表请求）
export const List = '/pcredit/activities'
// 免息活动详情 URL
export const Detail = (id) => `/pcredit/activities/${id}`
// 免息活动保存 URL（新建）
export const Save = '/pcredit/activities'

// 获取免息活动详情
export function getActivityDetail (activityId) {
  return fetch({
    url: `/pcredit/activities/${activityId}`,
    method: 'get'
  })
}

// 创建免息活动
export function createActivity (data) {
  return fetch({
    url: '/pcredit/activities',
    method: 'post',
    data
  })
}

// 更新免息活动
export function updateActivity (activityId, data) {
  return fetch({
    url: `/pcredit/activities/${activityId}`,
    method: 'put',
    data
  })
}

// 免息活动上架
export function onlineActivity (activityId) {
  return fetch({
    url: `/pcredit/activities/${activityId}/online`,
    method: 'post'
  })
}

// 免息活动下架
export function offlineActivity (activityId) {
  return fetch({
    url: `/pcredit/activities/${activityId}/offline`,
    method: 'post'
  })
}

// 获取活动关联经销商列表
export function getActivityDealers (activityId, params) {
  return fetch({
    url: `/pcredit/activities/${activityId}/dealers`,
    method: 'get',
    params
  })
}

// 重试单个经销商创建/同步
export function retryActivityDealer (activityId, dealerId) {
  return fetch({
    url: `/pcredit/activities/${activityId}/dealers/${dealerId}/retry`,
    method: 'post'
  })
}

// 重试活动下全部经销商创建/同步
export function retryAllActivityDealers (activityId) {
  return fetch({
    url: `/pcredit/activities/${activityId}/dealers/retry-all`,
    method: 'post'
  })
}

// 活动经销商上架
export function onlineActivityDealer (activityId, dealerId) {
  return fetch({
    url: `/pcredit/activities/${activityId}/dealers/${dealerId}/online`,
    method: 'post'
  })
}

// 活动经销商下架
export function offlineActivityDealer (activityId, dealerId) {
  return fetch({
    url: `/pcredit/activities/${activityId}/dealers/${dealerId}/offline`,
    method: 'post'
  })
}

// 获取活动参与商品（SKU）列表
export function getActivitySkus (activityId, params) {
  return fetch({
    url: `/pcredit/activities/${activityId}/skus`,
    method: 'get',
    params
  })
}

// 获取活动补贴流水列表（activity_id 有则传，无则不传）
export function getActivityFlows (params) {
  return fetch({
    url: '/pcredit/activities/flows',
    method: 'get',
    params
  })
}

// 获取平台通知配置
export function getPlatformNotifyConfig () {
  return fetch({
    url: '/pcredit/platform-notify-config',
    method: 'get'
  })
}

// 保存平台通知配置
export function savePlatformNotifyConfig (data) {
  return fetch({
    url: '/pcredit/platform-notify-config',
    method: 'put',
    data
  })
}
